import ListIcon from '@material-ui/icons/List';
import { IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useState } from 'react';
import PropertyItemsModal from '../../components/property-items-modal';

const PropertyItemLink = ({ listItem }) => {
  const [openModal, setOpenModal] = useState(false);

  const onOpenModal = () => setOpenModal(true);
  const closeModal = () => setOpenModal(false);

  if (!listItem) return null;

  return (
    <>
      <IconButton size="small" onClick={onOpenModal}>
        <ListIcon />
      </IconButton>
      <PropertyItemsModal open={openModal} onClose={closeModal} property={listItem} />
    </>
  );
};

PropertyItemLink.propTypes = {
  listItem: PropTypes.any,
};

PropertyItemLink.defaultProps = {
  listItem: null,
};

export default PropertyItemLink;
